export default __webpack_public_path__ + "static/media/netflix-marked.0d2e89e1.png";